export default __webpack_public_path__ + "b66a844.png";